import React from 'react';
import { Typography, Box, IconButton } from '@mui/material';
import { FooterContainer } from '../components';
import {
  GitHub as GitHubIcon,
  YouTube as YouTubeIcon,
  LinkedIn as LinkedInIcon,
  Instagram as InstagramIcon,
} from '@mui/icons-material';

export const Footer = (): React.ReactNode => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      icon: <GitHubIcon />,
      href: 'https://github.com/islommashanlo',
      label: 'GitHub',
    },
    {
      icon: <YouTubeIcon />,
      href: 'https://www.youtube.com/channel/UC0208gJUjWyIH0cJ6H9XoKA',
      label: 'YouTube',
    },
    {
      icon: <LinkedInIcon />,
      href: 'https://www.linkedin.com/in/islom-mashanlo/',
      label: 'LinkedIn',
    },
    {
      icon: <InstagramIcon />,
      href: 'https://www.instagram.com/isa.solaris/',
      label: 'Instagram',
    },
  ];

  return (
    <FooterContainer>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Typography
          variant='h6'
          sx={{
            textAlign: { xs: 'center', md: 'left' },
            color: 'text.primary',
            fontWeight: 'bold',
          }}
        >
          Designed and Developed by Islom Mashanlo
        </Typography>

        <Typography
          variant='body1'
          sx={{
            textAlign: 'center',
            color: 'text.secondary',
          }}
        >
          Copyright © {currentYear} SB
        </Typography>

        <Box
          sx={{
            display: 'flex',
            gap: 1,
          }}
        >
          {socialLinks.map(social => (
            <IconButton
              key={social.label}
              component='a'
              href={social.href}
              target='_blank'
              rel='noreferrer'
              aria-label={social.label}
              sx={{
                color: 'primary.main',
                backgroundColor: 'rgba(199, 112, 240, 0.1)',
                border: '1px solid transparent',
                transition: 'all 0.3s ease',
                '&:hover': {
                  backgroundColor: 'primary.main',
                  color: 'white',
                  transform: 'translateY(-3px)',
                  borderColor: 'primary.main',
                },
              }}
            >
              {social.icon}
            </IconButton>
          ))}
        </Box>
      </Box>
    </FooterContainer>
  );
};
